import { Job, JobSummary, JobDetailed } from '../types/Job';

export enum JOB_MAP_OPERATION {
    SUMARIZED = 'SUMARIZED',
    DETAILED = 'DETAILED',
}

const JobMapper: { [key: string]: any } = {
    [JOB_MAP_OPERATION.SUMARIZED]: (jobs: Job[]): JobSummary[] => {
        const objToMap = !Array.isArray(jobs) ? [jobs] : jobs;
        const mappedObj = objToMap.map((job, index) => ({
            key: `job_${job.id}_${index}`,
            id: job.id,
            status: job.status,
            pickUpAt: job.pickup_at,
            stackId: job.stack_id,
            clientReference: job.deliveries.map((delivery) => delivery.client_reference).join(`\n\n`),
            pickUpAddress: job.deliveries.map((delivery) => delivery.pickup.address.original_address).join(`\n\n`),
            dropOffAddress: job.deliveries.map((delivery) => delivery.dropoff.address.original_address).join(`\n\n`),
            createdAt: job.created_at,
            /* eslint-disable indent */
            ...(job.client_id && job.client_name
                ? {
                      client: {
                          id: job.client_id,
                          name: job.client_name,
                      },
                  }
                : {}),
            /* eslint-enable indent */
            api_job_id: job.api_job_id,
        }));
        return mappedObj;
    },
    [JOB_MAP_OPERATION.DETAILED]: (job: Job): JobDetailed => {
        return {
            id: job.id,
            status: job.status,
            createdAt: new Date(job.created_at).toLocaleString(),
            packageType: job.package_type,
            transportType: job.transport_type || '-',
            assignmentCode: job.assignment_code || '-',
            pickupAt: new Date(job.pickup_at).toLocaleString(),
            comment: job.comment,
            apiJobId: job.api_job_id || null,
            dashboardURL: job.dashboard_url,
            stackId: job.stack_id,
            deliveries: [
                ...job.deliveries.map((delivery) => ({
                    deliveryId: delivery.id,
                    key: `delivery_${delivery.id}`,
                    clientReference: delivery.client_reference,
                    packageDescription: delivery.package_description,
                    packageType: delivery.package_type,
                    pickup: { ...delivery.pickup },
                    dropoff: { ...delivery.dropoff },
                })),
            ],
            client_id: job.client_id,
            client_name: job.client_name,
        };
    },
};

export default JobMapper;
